import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Table, Alert, InputGroup } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
registerLocale('ko', ko);

// types
import { RESPONSE_CODE } from 'types/const';
// hooks
import useHistoryState from 'hooks/useHistoryState';
// api
import { quater, month } from 'api/haccp/monitoring/processApi';
import { excdInfoCount } from 'api/haccp/monitoring/commonApi';

/**
 *  @desciption 모니터링-공정
 */

const Process = props => {
  /* router info */
  const history = useHistory();

  /* state */
  const [tab] = useState(props.tab);
  const [pltCd] = useState(props.pltCd); // 공장코드
  const [ctgryGrpCd] = useState(props.ctgryGrpCd); // 분류코드
  const [baseYm, setBaseYm] = useHistoryState(new Date(), 'baseYm'); // 조회월
  const [isInspLimitCheck, setIsInspLimitCheck] = useState(false); // 한계기준 이탈여부
  // 유효성검증 모니터링(분기) Data
  const [quaterData, setQuaterData] = useState([]);
  // 모니터링(월) Data
  const [monthData, setMonthData] = useState([]);

  /* event */

  // 검사결과 목록페이지 이동
  const onInspectionResult = (
    count,
    inspTypeSeq,
    procsCd,
    procsInspReqCd,
    dateType,
    date
  ) => {
    if (count === '' || count === 0) return;

    const { regDtSt, regDtEn } = dateConvert(dateType, date);

    history.push({
      pathname: '/haccp/monitoring/process/result',
      state: {
        tab: tab,
        baseYm: baseYm,
        pltCd: pltCd,
        inspTypeSeq: inspTypeSeq,
        ctgryGrpCd: ctgryGrpCd,
        ctgry1Cd: procsCd,
        ctgry2Cd: procsInspReqCd,
        dateType: dateType,
        date: date,
        regDtSt: regDtSt,
        regDtEn: regDtEn
      }
    });
  };

  // 한계기준이탈 목록페이지 이동
  const onCriticalLimit = () => {
    history.push({
      pathname: '/haccp/monitoring/criticalLimit',
      state: {
        tab: tab,
        pltCd: pltCd,
        ctgryGrpCd: ctgryGrpCd,
        baseYm: baseYm
      }
    });
  };

  /* method */
  // 조회 API 호출
  const onSearch = async () => {
    const year = Number(moment(baseYm).format('YYYY'));
    const month = Number(moment(baseYm).format('MM'));

    const params = {
      pltCd: pltCd,
      ctgryGrpCd: ctgryGrpCd,
      year: year,
      month: month
    };

    /* 유효성검증 모니터링(분기) */
    quaterProcess(params);

    /* 유효성검증 모니터링(월) */
    monthProcess(params);

    /* 이탈내역조치현황 및 한계기준이탈현황 API 호출 */
    departureMeasures(params);
  };

  /**
   * 유효성검증 모니터링(분기)
   */
  const quaterProcess = async params => {
    const response = await quater(params);
    const { code, list = [] } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    setQuaterData(list);
  };

  /**
   * 유효성검증 모니터링(월)
   */
  const monthProcess = async params => {
    const response = await month(params);
    const { code, list = [] } = response || {};
    if (code !== RESPONSE_CODE.Success) return;
    setMonthData(list);
  };

  /**
   * 이탈내역 조치현황 및 한계기준이탈현황 API
   */
  const departureMeasures = async params => {
    const response = await excdInfoCount(params);
    const { code, data } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    // 한계기준이탈 알림
    setIsInspLimitCheck(data?.limitExcdCnt > 0 ? true : false);
  };

  // 공정모니터링 분기,월 DATE 설정
  const dateConvert = (dateType, date) => {
    let regDtSt = null;
    let regDtEn = null;
    const year = moment(baseYm).year();

    switch (dateType) {
      case 'quater':
        // 분기
        regDtSt = moment(baseYm).quarter(date).startOf('Q').toDate();
        regDtEn = moment(baseYm).quarter(date).endOf('Q').toDate();
        break;
      case 'month':
        regDtSt = moment([year, date - 1])
          .startOf(dateType)
          .toDate();
        regDtEn = moment([year, date - 1])
          .endOf(dateType)
          .toDate();
        break;
    }

    return { regDtSt, regDtEn };
  };
  /* watch */
  useEffect(() => {
    // 조회 API 호출
    onSearch();
  }, [baseYm]);

  return (
    <>
      <Row className="ms-0 me-0 mt-3">
        <Col sm={3} className="ps-0">
          <InputGroup size="sm" className="mb-3">
            <InputGroup.Text>조회월</InputGroup.Text>
            <div className="flex-fill">
              <DatePicker
                onKeyDown={e => {
                  e.preventDefault();
                }}
                locale="ko"
                dateFormat="yyyy년 MM월"
                className="form-control form-control-sm"
                showMonthYearPicker
                onChange={e => setBaseYm(e)}
                selected={baseYm}
              />
            </div>
          </InputGroup>
        </Col>
        {/* SFSH TODO 미사용 확정시 삭제예정*/}
        {/* {isInspLimitCheck === true && (
          <Col sm={'auto'} className="pe-0 ms-auto">
            <Flex>
              <Alert
                variant="danger cursor-pointer"
                className="fs--1 mb-0 py-2"
                onClick={() => onCriticalLimit()}
              >
                {moment(baseYm).format('YYYY년MM월')} 검사결과 한계기준 이탈 내역이 있습니다.
              </Alert>
            </Flex>
          </Col>
        )} */}
      </Row>
      <Row className="ms-0 me-0 mt-3">
        {/* 유효성검증 모니터링 */}
        <Col className="ps-0">
          <Flex justifyContent="between" className="mb-3">
            <h6 className="fs-0 mb-0">*유효성검증 모니터링</h6>
          </Flex>
          <div className="scrollbar" style={{ maxHeight: '360px' }}>
            <Table bordered className="fs--1 text-center mb-0">
              <thead
                className="bg-200 text-700 align-middle border-300"
                style={{ position: 'sticky', top: 0 }}
              >
                <tr rowSpan={2}>
                  <th className="text-nowrap" rowSpan={2}>
                    공정명
                  </th>
                  <th className="text-nowrap" rowSpan={2}>
                    의뢰명
                  </th>
                  <th className="text-nowrap" colSpan={4}>
                    검증주기
                  </th>
                </tr>
                <tr>
                  <th className="bg-200 border-300 fs--2">1분기</th>
                  <th className="bg-200 border-300 fs--2">2분기</th>
                  <th className="bg-200 border-300 fs--2">3분기</th>
                  <th className="bg-200 border-300 fs--2">4분기</th>
                </tr>
              </thead>
              <tbody className="align-middle">
                {quaterData?.map(
                  (
                    {
                      procsNm,
                      procsInspReqNm,
                      inspTypeSeq,
                      procsCd,
                      procsInspReqCd,
                      quater1,
                      quater2,
                      quater3,
                      quater4
                    },
                    index
                  ) => (
                    <tr key={index} className="border-300 border-bottom">
                      <td className="bg-200"> {procsNm || '-'} </td>
                      <td className="bg-200"> {procsInspReqNm || '-'} </td>
                      <td
                        className={quater1 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            quater1,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'quater',
                            1
                          )
                        }
                      >
                        {quater1 || '-'}
                      </td>
                      <td
                        className={quater2 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            quater2,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'quater',
                            2
                          )
                        }
                      >
                        {quater2 || '-'}
                      </td>
                      <td
                        className={quater3 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            quater3,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'quater',
                            3
                          )
                        }
                      >
                        {quater3 || '-'}
                      </td>
                      <td
                        className={quater4 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            quater4,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'quater',
                            4
                          )
                        }
                      >
                        {quater4 || '-'}
                      </td>
                    </tr>
                  )
                )}
                {quaterData?.length < 1 && (
                  <tr>
                    <td colSpan={6} className="w-auto">
                      유효성검증 모니터링 데이터가 존재하지 않습니다.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
      <Row className="ms-0 me-0 mt-3">
        {/* 모니터링-월 */}
        <Col className="ps-0">
          <Flex justifyContent="between" className="mb-3">
            <h6 className="fs-0 mb-0">*모니터링</h6>
          </Flex>
          <div className="scrollbar" style={{ maxHeight: '275px' }}>
            <Table responsive bordered className="fs--1 text-center mb-0">
              <thead className="bg-200 text-700 align-middle border-300">
                <tr>
                  <th className="text-nowrap">공정명</th>
                  <th className="text-nowrap">의뢰명</th>
                  <th className="text-nowrap">1월</th>
                  <th className="text-nowrap">2월</th>
                  <th className="text-nowrap">3월</th>
                  <th className="text-nowrap">4월</th>
                  <th className="text-nowrap">5월</th>
                  <th className="text-nowrap">6월</th>
                  <th className="text-nowrap">7월</th>
                  <th className="text-nowrap">8월</th>
                  <th className="text-nowrap">9월</th>
                  <th className="text-nowrap">10월</th>
                  <th className="text-nowrap">11월</th>
                  <th className="text-nowrap">12월</th>
                </tr>
              </thead>
              <tbody className="align-middle">
                {monthData?.map(
                  (
                    {
                      procsNm,
                      procsInspReqNm,
                      inspTypeSeq,
                      procsCd,
                      procsInspReqCd,
                      month1,
                      month2,
                      month3,
                      month4,
                      month5,
                      month6,
                      month7,
                      month8,
                      month9,
                      month10,
                      month11,
                      month12
                    },
                    index
                  ) => (
                    <tr
                      key={index}
                      style={{ position: 'sticky', top: '44.98px' }}
                      className="border-300 border-bottom"
                    >
                      <td className="bg-200"> {procsNm || '-'} </td>
                      <td className="bg-200"> {procsInspReqNm || '-'} </td>
                      <td
                        className={month1 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month1,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            1
                          )
                        }
                      >
                        {month1 || '-'}
                      </td>
                      <td
                        className={month2 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month2,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            2
                          )
                        }
                      >
                        {month2 || '-'}
                      </td>
                      <td
                        className={month3 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month3,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            3
                          )
                        }
                      >
                        {month3 || '-'}
                      </td>
                      <td
                        className={month4 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month4,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            4
                          )
                        }
                      >
                        {month4 || '-'}
                      </td>
                      <td
                        className={month5 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month5,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            5
                          )
                        }
                      >
                        {month5 || '-'}
                      </td>
                      <td
                        className={month6 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month6,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            6
                          )
                        }
                      >
                        {month6 || '-'}
                      </td>
                      <td
                        className={month7 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month7,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            7
                          )
                        }
                      >
                        {month7 || '-'}
                      </td>
                      <td
                        className={month8 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month8,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            8
                          )
                        }
                      >
                        {month8 || '-'}
                      </td>
                      <td
                        className={month9 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month9,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            9
                          )
                        }
                      >
                        {month9 || '-'}
                      </td>
                      <td
                        className={month10 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month10,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            10
                          )
                        }
                      >
                        {month10 || '-'}
                      </td>
                      <td
                        className={month11 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month11,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            11
                          )
                        }
                      >
                        {month11 || '-'}
                      </td>
                      <td
                        className={month12 !== 0 ? 'cursor-pointer' : ''}
                        onClick={() =>
                          onInspectionResult(
                            month12,
                            inspTypeSeq,
                            procsCd,
                            procsInspReqCd,
                            'month',
                            12
                          )
                        }
                      >
                        {month12 || '-'}
                      </td>
                    </tr>
                  )
                )}
                {monthData?.length < 1 && (
                  <tr>
                    <td colSpan={14} className="w-auto">
                      모니터링 데이터가 존재하지 않습니다.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Process;
